import { DialogRoot } from "@radix-ui/themes";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useForm, Controller } from "react-hook-form";
import { useFetch } from "../../../../hooks/useFetch";
import { DialogClose, DialogContent } from "../../../../ui/Dialog";
import { Label } from "../../../../ui/Label/Label";
import { Input } from "../../../../ui/Input/Input";
import { Button } from "../../../../ui/Button";
import { SensorsTableData } from "../../../../types/formDataTypes";

type Props = {
  id: string;
  isEditOpen: boolean;
  closeModal: Function;
  data: SensorsTableData[];
  refreshItems: Function;
};

const EditDevice = ({ id, isEditOpen, closeModal, data, refreshItems }: Props) => {
  const currentData = data.find((r) => r.id == Number(id));

  const { register, reset, handleSubmit, control } = useForm({
    defaultValues: {
      factor: currentData?.factor ? currentData?.factor : "",
      idle_level: String(currentData?.idle_level),
      power_factor: currentData?.power_factor ? currentData?.power_factor : "",
      turned_off_level: String(currentData?.turned_off_level),
    },
  });

  const openStateChange = () => {
    if (isEditOpen) closeModal();
  };

  const [{ response: itemUpdateResponse, isLoading: itemUpdateIsLoading, error: itemUpdateError }, doFetchItemUpdate] =
    useFetch(`/devices/sensors/${id}`);

  const onSubmit = (formData: any) => {
    doFetchItemUpdate({
      method: "PUT",
      data: {
        data: {
          factor: formData.factor,
          idle_level: formData.idle_level,
          power_factor: formData.power_factor,
          turned_off_level: formData.turned_off_level,
        },
      },
    });
    reset();
  };

  useEffect(() => {
    if (itemUpdateResponse) {
      refreshItems();
      openStateChange();
    }
  }, [itemUpdateResponse]);

  // let [isDeleteOpen, setIsDeleteOpen] = useState(false);

  // function openDeleteModal() {
  //   setIsDeleteOpen(true);
  // }

  // function closeDeleteModal() {
  //   setIsDeleteOpen(false);
  // }

  // function onItemDelete(): void {
  //   openDeleteModal();
  // }

  return (
    <DialogRoot open={isEditOpen} onOpenChange={openStateChange}>
      <DialogContent style={{ maxWidth: 440, position: "fixed", top: "30%" }}>
        <div className="text-lg font-medium">{t("adding_device_constants")}</div>
        <div className="text-sm">{t("adding_device_constants_form_text")}</div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="w-full items-end gap-4 mt-4">
            <div className="grid grid-cols-1 items-end w-full gap-4">
              <Controller
                name="factor"
                control={control}
                render={({ field }) => (
                  <div className="relative flex flex-col space-y-2">
                    <Label>{t("factor")}</Label>
                    <Input {...field} />
                  </div>
                )}
              />

              <Controller
                name="idle_level"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div className="relative flex flex-col space-y-2">
                    <Label>{t("idle_level")}*</Label>
                    <Input {...field} />
                  </div>
                )}
              />

              <Controller
                name="turned_off_level"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div className="relative flex flex-col space-y-2">
                    <Label>{t("turned_off_level")}*</Label>
                    <Input {...field} />
                  </div>
                )}
              />

              <Controller
                name="power_factor"
                control={control}
                render={({ field }) => (
                  <div className="relative flex flex-col space-y-2">
                    <Label>{t("power_factor")}</Label>
                    <Input {...field} />
                  </div>
                )}
              />
            </div>
            <div className="flex justify-between mt-4">
              {/* <Button type="button" variant={"destructive"} size={"sm"} onClick={onItemDelete}>
                {t("delete")}
              </Button> */}
              <Button variant={"default"} size={"sm"}>
                {t("save")}
              </Button>
            </div>
          </div>
        </form>
      </DialogContent>
      {/* <DeleteModel
        id={id}
        isDeleteOpen={isDeleteOpen}
        closeModal={closeDeleteModal}
        refreshModels={refreshModels}
        closeModalOnDelete={closeModal}
      /> */}
    </DialogRoot>
  );
};

export default EditDevice;
